<div #wrapper class="wrapper"><div class="spacer">&nbsp;</div><div #marquee class="marquee">{{text}}</div></div>
